module.exports = __webpack_public_path__ + "static/media/logo.993efdd5.png";